// Curated multi-stop "Food Trails" — pre-built crawls through a neighbourhood
// or theme. Each references real restaurant ids from restaurants.js.
export const FOOD_TRAILS = [
  {
    id: 'calgary-17th-icons',
    title: 'The 17th Avenue Icons',
    city: 'Calgary',
    tagline: 'Six blocks, six defining Calgary kitchens',
    blurb: "Calgary's culinary heart in one walkable stretch — a veg-forward brunch, wood-fired pizza, natural wine, and late-night yakitori.",
    stops: ['ten-foot-henry', 'una-pizza', 'pigeonhole', 'model-milk', 'shokunin'],
  },
  {
    id: 'edmonton-new-wave',
    title: "Edmonton's New Wave",
    city: 'Edmonton',
    tagline: 'The buzziest new tables in the city',
    blurb: 'Brewery District Italian, a nationally ranked cocktail lounge, and the 124 Street rooms everyone is talking about right now.',
    stops: ['nero-yeg', 'next-of-kin', 'north-53', 'little-wolf', 'clementine'],
  },
  {
    id: 'calgary-cocktail-trail',
    title: 'The Calgary Cocktail Trail',
    city: 'Calgary',
    tagline: 'From natural wine to a password-only speakeasy',
    blurb: 'A night built around Calgary\'s best bars — candlelit wine, a cosy Beltline hideaway, a world-class cocktail room, and a hidden speakeasy.',
    stops: ['pigeonhole', 'milk-tiger', 'proof-yyc', 'betty-lous-library', 'two-penny'],
  },
  {
    id: 'edmonton-sushi-izakaya',
    title: 'Sushi & Izakaya Night',
    city: 'Edmonton',
    tagline: 'Omakase splurge meets Osaka energy',
    blurb: 'Edmonton\'s sushi scene, done properly — a chef-guided omakase counter and the lively izakaya rooms that round out the night.',
    stops: ['mssm', 'dorinku', 'koto'],
  },
  {
    id: 'banff-apres-trail',
    title: 'The Banff Après Trail',
    city: 'Banff',
    tagline: 'Mountain spirits, from distillery to castle bar',
    blurb: 'Wind down after the slopes or the trails with the best of Banff\'s bar scene — house-distilled cocktails, Rocky Mountain plates, and a grand fireside lounge fit for a castle.',
    stops: ['park-distillery', 'the-bison', 'rundle-bar-banff'],
  },
  {
    id: 'canmore-apres-trail',
    title: 'The Canmore Après Trail',
    city: 'Canmore',
    tagline: 'Distillery cocktails to Main Street saloon',
    blurb: 'Canmore\'s drinks scene has quietly gotten very good. Start with grain-to-glass cocktails, graduate to a see-and-be-seen dinner, and end the night whooping it up in a Main Street saloon.',
    stops: ['wild-life-distillery', 'bridgette-bar-canmore', 'buffalo-roam-saloon'],
  },
];
